import t from 'tcomb-form'

const createConfigurationModel = t.struct({
    username: t.String,
    password: t.String
})

export default createConfigurationModel



// WEBPACK FOOTER //
// ./src/screens/login/components/forms/Login/model.js